import { api } from '../api-client.config';

export const listFiles = async (prefix = ''): Promise<{ files: { blobName: string; blobUrl: string }[] }> => {
  return api.get('/files/list', {
    params: { prefix },
  });
};
